// Fetches ephemeral error detail via App Proxy, falls back gracefully.
(function(){
  function text(el,id){ return el.querySelector(id); }
  const params = new URLSearchParams(window.location.search);
  const code = (params.get('code')||'').toUpperCase();
  const id = params.get('id');
  const msgEl = document.getElementById('sso-error-msg');
  const retry = document.getElementById('sso-retry-link');

  function show(message, opts={}){
    msgEl.textContent = message;
    if (opts.showRetry) retry.style.display = 'inline-block';
  }

  // Generic dictionary (client side fallback)
  const FALLBACK = {
    SSO_FAILED: 'Single sign-on failed. Please try again.',
    BAD_REQUEST: 'The request was invalid. Please retry.',
    DEFAULT: 'An unexpected error occurred. Please retry.'
  };

  if(!code){
    show('Missing error code.', {showRetry:true});
    return;
  }

  if(!id){
    // No ephemeral id: show static mapping only
    show(FALLBACK[code] || FALLBACK.DEFAULT, {showRetry:true});
    return;
  }

  // App Proxy path exposed publicly
  const url = `/apps/sso/multipass/public/error?id=${encodeURIComponent(id)}`;

  // 3s abort to avoid hanging
  const c = new AbortController();
  setTimeout(()=>c.abort(),3000);

  fetch(url,{signal:c.signal,credentials:'same-origin'})
    .then(r=> r.ok ? r.json() : null)
    .then(data=>{
      if(data && data.success && data.displayMessage){
        show(data.displayMessage, {showRetry:true});
      } else {
        show(FALLBACK[code] || ('Error: '+code), {showRetry:true});
      }
    })
    .catch(()=>{
      show(FALLBACK[code] || FALLBACK.DEFAULT, {showRetry:true});
    });
})();